module.exports = __webpack_public_path__ + "static/media/newheroimgR.276f3748.svg";